import { motion } from 'framer-motion';
import styled from 'styled-components';

import structure from 'assets/styles/variables/structure';

export const StyledContainer = styled(motion.div)`
	width: ${structure.container.mobileWidth};
	max-width: ${structure.container.maxWidth};
	padding: 0 ${structure.container.mobilePadding};
`;